export const ACCURACY_SUMMARY_REPORTS = Object.freeze({
    CP: 'CP',
    CPLF: 'CPLF',
    OP: 'OP',
});


// WEBPACK FOOTER //
// ./src/constants/accuracy_summary_reports.jsx